"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollTo = scrollTo;
function scrollTo() {
    const tocItems = document.querySelectorAll('.hero__item-lnk');
    if (!tocItems.length)
        return;
    const contentBlocks = document.querySelectorAll('.toc-target');
    const len = Math.min(tocItems.length, contentBlocks.length);
    for (let i = 0; i < len; i++) {
        const target = contentBlocks[i];
        tocItems[i].onclick = () => {
            const y = target.getBoundingClientRect().top + window.pageYOffset - 40;
            window.scrollTo({ top: y, behavior: 'smooth' });
        };
    }
}
